import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';

class DropdownCommunity extends Component {
  static propTypes = {
    currentItem: PropTypes.object,
    items: PropTypes.array.isRequired,
  };

  static defaultProps = {
    currentItem: {
      name: 'Union',
    },
  };

  renderTrigger = () => {
    const currentItem = this.props.items.find(item => item.slug === this.props.currentItem.slug);
    return <span className="u-hidden sm:u-inline u-mr-1">{currentItem ? currentItem.name : 'Home'}</span>;
  };

  renderItem = item => (
    <a href={item.url} className="dropdown-item u-flex u-items-center">
      <img
        src={item.logo}
        alt={item.name}
        className="u-rounded-sm u-mr-2 u-w-6 u-h-6"
        draggable="false"
      />
      {item.name}
    </a>
  );

  render() {
    const items = this.props.items.filter(item => item.slug !== this.props.currentItem.slug);

    // There's no links for other communities, so we show a button instead of dropdown
    // In this case it'll show "Union" or a network name if there's a @community variable
    // set (for eg. during the application process)
    if (this.props.items.length === 0) {
      return (
        <a href="/" className="dropdown-trigger u-px-3">
          {this.props.currentItem.name}
        </a>
      );
    // This user is non-inactive in a single network, so we show a button instead of dropdown
    } else if (this.props.items.length === 1) {
      return (
        <a href={this.props.items[0].url} className="dropdown-trigger u-px-3">
          {this.props.items[0].name}
        </a>
      );
    }
    return (
      <Dropdown
        items={items}
        renderItem={this.renderItem}
        renderTrigger={this.renderTrigger}
        listClassName="topbar-dropdown u-scrollbar"
        carretClassName=""
        {...this.props}
      />
    );
  }
}

export default DropdownCommunity;
